/**
 * @param {String} [cookieName]
 *
 * @return {String} CSRF token stored in cookie or empty string if not present
 */
export default function getCSRFCookie(cookieName = "delegate-csrf-token") {
  const matches = document.cookie.match("(^|;)\\s*" + cookieName + "\\s*=\\s*([^;]+)");

  return matches ? matches.pop() : "";
}
